import { createContext } from 'react';
import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';

export const AppContext = createContext({
  user: null,
  setUser: () => {},
  isAuth: false,
  setIsAuth: () => {},
  logout: () => {},
  ticketsToBeMoved: [],
  userMode: '',
  setUserMode: () => {},
});

function AppProvider({ children }) {
  const [user, setUser] = useState(() => {
    return localStorage.getItem('user') || null;
  });

  const [isAuth, setIsAuth] = useState(false);

  const [userMode, setUserMode] = useState(() => {
    return localStorage.getItem('userMode') || '';
  });

  function setUserInfo(userInfo) {
    setUser(userInfo);
    localStorage.setItem('user', userInfo);
  }

  function setAuthStatus() {
    setIsAuth(true);
  }

  function logout() {
    setUser(null);
    setIsAuth(false);
    localStorage.removeItem('isAuth');
    localStorage.removeItem('user');
    localStorage.removeItem('userMode');
  }

  function uMode(mode) {
    setUserMode(mode);
    localStorage.setItem('userMode', mode);
  }

  const value = {
    user: user,
    setUser: setUserInfo,
    isAuth: isAuth,
    setIsAuth: setAuthStatus,
    logout: logout,
    userMode: userMode,
    setUserMode: uMode,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
export default AppProvider;

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
